import { TrendingUp } from "lucide-react";

export function RevenueGrowth({ content }) {
  const amounts = (content.items || []).map((item) => Number(String(item.value).replace(/[^0-9.]/g, "")) || 0);
  const maxAmount = Math.max(...amounts, 1);
  const firstAmount = amounts[0] || 0;
  const lastAmount = amounts[amounts.length - 1] || 0;
  const growthPercent = firstAmount ? Math.round(((lastAmount - firstAmount) / firstAmount) * 100) : 0;
  const firstYear = content.items?.[0]?.year || "";
  const lastItem = content.items?.[content.items.length - 1];

  return (
    <section id="revenue" className="section revenue-section" data-testid="revenue-section">
      <div className="section-heading wide">
        <p className="overline" data-testid="revenue-overline">{content.overline}</p>
        <h2 data-testid="revenue-title">{content.title}</h2>
        <p data-testid="revenue-description">{content.description}</p>
      </div>

      <div className="revenue-chart" data-testid="revenue-chart">
        {(content.items || []).map((item, index) => {
          const amount = amounts[index] || 0;
          const barHeight = Math.max(28, Math.round((amount / maxAmount) * 100));
          return (
            <article className="revenue-bar-card" key={item.year} data-testid={`revenue-card-${index + 1}`}>
              <div className="revenue-bar-track" data-testid={`revenue-bar-track-${index + 1}`}>
                <div className="revenue-bar-fill" style={{ height: `${barHeight}%` }} data-testid={`revenue-bar-fill-${index + 1}`} />
              </div>
              <div className="revenue-bar-copy">
                <span data-testid={`revenue-year-${index + 1}`}>{item.year}</span>
                <strong data-testid={`revenue-value-${index + 1}`}>{item.value}</strong>
                <p data-testid={`revenue-label-${index + 1}`}>{item.label}</p>
              </div>
            </article>
          );
        })}
      </div>

      <div className="revenue-insight-strip" data-testid="revenue-insight-strip">
        <div className="revenue-insight-icon" data-testid="revenue-insight-icon"><TrendingUp size={24} aria-hidden="true" /></div>
        <strong data-testid="revenue-growth-percent">+{growthPercent}%</strong>
        <span data-testid="revenue-growth-note">{firstYear} → {lastItem?.year} · {lastItem?.label}</span>
      </div>
    </section>
  );
}